import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { EmployeeWaitingIconSvg } from '../../../../lib/icons';
import { useCreateImport } from '../hooks/useCreateImport';
import { Button } from '../../../../lib/components/atomic/button';

export const ConfirmationStep: FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { newImport } = useCreateImport();

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      height="100%"
      textAlign={'center'}
    >
      <EmployeeWaitingIconSvg />
      <Typography variant="subtitle1" fontSize="1.5rem" color="heaven.main" marginTop="3rem">
        {t('employee:IMPORT_PENDING_TITLE', { context: newImport.type })}
      </Typography>
      <Typography variant="subtitle1" color="heaven.main" width={{ md: '70%' }}>
        {t('employee:IMPORT_PENDING_MESSAGE')}
      </Typography>
      <Button onClick={() => navigate('/imports')} className="mt-10">
        {t('common:TO_IMPORTS_OVERVIEW')}
      </Button>
    </Box>
  );
};
